module.exports = __webpack_public_path__ + "img/pexels-pixabay-50987-com.144b0066.jpg";